<template>
    <div class="container my-5">
        <div class="aguarde text-center" v-if="this.loading">
            <div class="spinner-border" role="status"></div>
            <br>
            <span>Aguarde...</span>
        </div>
        <div v-if="!this.loading">
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col">Nº Protocolo</th>
                        <th scope="col">Situação</th>
                        <th scope="col">Data do agendamento</th> 
                        <th scope="col">Especialidade</th> 
                        <th scope="col">Acesso</th> 
                    </tr>
                </thead>
                <tbody>
                    <tr  v-for="(item, index) in agendamentos"  :key="index">
                        <td>{{item.protocolo}}</td>
                        <td>{{item.status}}</td>
                        <td>{{formatDate(item.dataHoraConfirmada)}}</td>
                        <td>{{item.especialidade}}</td>
                        <td><a :href="item.urlSala" v-if="item.urlSala">Entre na sala</a></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { APIService } from "../APIService";
const apiService = new APIService();

export default {
 name: "ServicoAgendamentos",
  props: [],
  data() {
    return {
        agendamentos: [],
        loading: false
    };
  },
  computed: {

  },
  created() {
      this.obterAgendamentos();
  },
  methods: {
    
        formatDate(date) {
            return this.$moment(date, "DD/MM/YYYY HH:mm:ss");
        },
        obterAgendamentos(){
            this.loading = true;
            apiService.obterAgendamentos()
                      .then(response => {

                this.agendamentos = response;
                this.loading = false;
            });
        }

  },
 
}

</script>

<style  scoped lang="scss">

</style>